import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver went on duty without driving.
 */
export const onDutyV1 = tmsEventKind(
  { category: "dutyStatus", kind: "onDuty", version: 1 },
  {
    refs: dutyStatusChangeRefs,
    facts: {
      /** Whether a second driver was signed in — a flag, never the co-driver's identity. */
      withCoDriver: z.boolean(),
    },
  },
);

export const OnDutyV1Schema = onDutyV1.schema;
export const OnDutyV1FactsSchema = onDutyV1.facts;

export type OnDutyV1 = z.infer<typeof OnDutyV1Schema>;
export type OnDutyV1Facts = z.infer<typeof OnDutyV1FactsSchema>;

/** Every version of `onDuty`, keyed by version. What `catalog.ts` places under `dutyStatus`. */
export const onDuty = { 1: onDutyV1 } as const;
